
<script setup>

  import { ref, computed } from 'vue';

  const props = defineProps( {
    
    id: String,
    
    maxLength: { type: Number, default: 1000 },
    
    modelValue: String
  
  } );

  const emit = defineEmits( [ 'update:modelValue' ] );

  const textarea = ref( null );

  const data = ref( props.modelValue );

  const count = computed( () => data.value?.length || 0 );

  function onInput( event ) {

    data.value = event.target.value;

    emit( 'update:modelValue', data.value );

  }

</script>

<template>

  <div data-curled-page class="cursor-text border-[40px] xl:border-[80px] drop-shadow-[0_0_5px_rgba(0,0,0,0.25)]" @click="textarea.focus()">

    <div class="w-full h-full bg-neutral-200">

      <textarea :id="id" :value="data" @input="onInput" :maxLength="maxLength" ref="textarea"
      
        class="block w-full h-full border-0 bg-transparent resize-none
        
          placeholder:text-neutral-400 focus:ring-2 focus:ring-inset focus:ring-neutral-400 sm:text-sm sm:leading-6" />

      <div class="text-right mt-2 text-sm italic">{{ count }} of {{ maxLength }} characters used.</div>

    </div>

  </div>

</template>

<style scoped>

  [ data-curled-page ] {

    border-image: url( ../images/curled-page-border.svg );

    border-image-slice: 150 150 150 150;

  }

</style>
